import { useEffect, useState } from "react";
import { Loader2, ClipboardList } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { adminApi } from "@/lib/adminApi";
import { StatusBadge } from "@/components/admin/_shared";
import { toast } from "sonner";

const STATUSES = [["pending", "Pending"], ["in_progress", "In Progress"], ["ready_for_review", "Ready for Review"], ["completed", "Completed"]];

export default function AdminDFY() {
  const [queue, setQueue] = useState(null);
  const load = () => adminApi.get("/admin/dfy-queue").then((r) => setQueue(r.data.queue)).catch(() => {});
  useEffect(() => { load(); }, []);

  const update = async (uid, status) => {
    try { await adminApi.patch(`/admin/dfy-queue/${uid}`, { status }); toast.success("Status updated"); load(); }
    catch (e) { toast.error("Could not update"); }
  };

  if (!queue) return <div className="flex justify-center py-20"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;

  return (
    <div data-testid="admin-dfy">
      <h1 className="font-heading text-2xl font-bold tracking-tight flex items-center gap-2"><ClipboardList className="h-6 w-6 text-blue-600" /> Done-For-You Setup Queue</h1>
      <p className="text-slate-500 mt-1 text-sm">Customers who purchased the £149 setup service.</p>
      <div className="mt-5 rounded-xl border border-slate-200 bg-white overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500"><tr>
            <th className="text-left font-semibold px-4 py-3">Business</th><th className="text-left font-semibold px-4 py-3">Owner</th>
            <th className="text-left font-semibold px-4 py-3">Email</th><th className="text-left font-semibold px-4 py-3">Plan</th>
            <th className="text-left font-semibold px-4 py-3">Payment</th><th className="text-left font-semibold px-4 py-3">Questionnaire</th><th className="text-left font-semibold px-4 py-3">Setup status</th>
          </tr></thead>
          <tbody className="divide-y divide-slate-100">
            {queue.length === 0 && <tr><td colSpan={7} className="py-12 text-center text-slate-400">No setup orders yet</td></tr>}
            {queue.map((q) => (
              <tr key={q.user_id} data-testid={`dfy-row-${q.user_id}`}>
                <td className="px-4 py-3 font-semibold">{q.business_name}</td>
                <td className="px-4 py-3">{q.owner}</td>
                <td className="px-4 py-3 text-slate-500">{q.email}</td>
                <td className="px-4 py-3">{q.plan || "—"}</td>
                <td className="px-4 py-3"><span className="text-emerald-600 text-xs font-semibold capitalize">{q.payment_status}</span></td>
                <td className="px-4 py-3">
                  {q.questionnaire_completed
                    ? <span data-testid={`dfy-q-${q.user_id}`} className="text-emerald-600 text-xs font-semibold">Completed</span>
                    : <span data-testid={`dfy-q-${q.user_id}`} className="text-amber-600 text-xs font-semibold">Awaiting</span>}
                </td>
                <td className="px-4 py-3">
                  <Select value={q.setup_status} onValueChange={(v) => update(q.user_id, v)}>
                    <SelectTrigger data-testid={`dfy-status-${q.user_id}`} className="w-52 h-8"><SelectValue /></SelectTrigger>
                    <SelectContent>{STATUSES.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent>
                  </Select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
